import React from 'react';
import { 
  Search, 
  GitBranch, 
  AlertCircle, 
  Terminal,
  Zap,
  History,
  Clock,
  ArrowRight
} from 'lucide-react';
import { Button } from '../../../components/ui/button';

const features = [
  {
    icon: GitBranch,
    title: "One-Click GitHub Setup",
    description: "Get started in seconds with our GitHub App. Install once and automatically track all commits and changes from your selected repositories.",
    highlight: "Instant onboarding"
  },
  {
    icon: Search,
    title: "Unified Search",
    description: "Search across all your systems and changes in one place. Find any deployment, config change, or script execution instantly.",
    highlight: "10x faster incident resolution"
  },
  {
    icon: AlertCircle,
    title: "Vector Based Semantic Search",
    description: "Our system analyzes changes and correlates them with incidents to help you identify the root cause faster than ever.",
    highlight: "High accuracy rate"
  },
  {
    icon: Terminal,
    title: "Script & Migration Tracking",
    description: "Never lose track of database migrations or one-off scripts again. Complete audit trail of every execution.",
    highlight: "Full audit compliance"
  }
];

const additionalFeatures = [
  {
    icon: Zap,
    title: "Real-time Updates",
    description: "See changes as they happen across your entire infrastructure."
  },
  {
    icon: History,
    title: "Historical Data",
    description: "Access complete history of all system changes with powerful filtering."
  },
  {
    icon: Clock,
    title: "Time Travel",
    description: "See your system state at any point in time with our timeline view."
  }
];

const FeaturesSection = () => {
  return (
    <div className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Features */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Everything You Need to Track Changes
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            DeltaOps gives you complete visibility into every change across your infrastructure
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div 
              key={feature.title}
              className="relative bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
                    <feature.icon className="h-6 w-6 text-blue-600" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 mb-4">{feature.description}</p>
                  <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 border border-blue-100">
                    <span className="text-sm font-medium text-blue-600">{feature.highlight}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;